
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.979 14.666H7.02a.653.653 0 00-.638.667c0 .369.286.667.638.667H22.98a.653.653 0 00.638-.667.653.653 0 00-.638-.667zM7.021 10.667h6.383a.653.653 0 00.638-.667.653.653 0 00-.638-.666H7.021a.653.653 0 00-.638.666c0 .369.286.667.638.667zM22.979 20H7.02a.653.653 0 00-.638.667c0 .368.286.666.638.666H22.98a.653.653 0 00.638-.666.653.653 0 00-.638-.667zM22.979 25.334H7.02a.653.653 0 00-.638.666c0 .369.286.667.638.667H22.98a.653.653 0 00.638-.667.653.653 0 00-.638-.666zM22.979 30.666H7.02a.653.653 0 00-.638.667c0 .369.286.667.638.667H22.98a.653.653 0 00.638-.667.653.653 0 00-.638-.666z","fill":"#323232"}}),_c('path',{attrs:{"d":"M20.69 0H0v40h30V9.724L20.69 0zm.374 2.276l6.757 7.057h-6.757V2.276zM1.277 38.666V1.334h18.51v9.334h8.936v28H1.277z","fill":"#323232"}})])
          )
        }
      }
    